import * as placeTokens from "../constants/PlaceTokens";
import * as places from "./places";
import * as cmn from "../common/NamaCommon";
import {areEqual, getFirstNotNullObj, isEmptyOrNull, isNotEmptyOrNull, namaCompare, noMenu} from "../common/NamaCommon";
import * as presenters from "./Presenters";
import * as editPresenter from "./EditPresenter";
import * as errors from "../common/ErrorsNotification";
import {getName, translateId} from "../common/Translator";
import * as app from "../views/mainapp";
import {isCurrentLogInInfoValid} from "../login/Security";
import {currentLoginInfo} from "../login/LoginPresenter";
import * as MainMenu from "../views/MainMenu";
import {destroyKendoWidgets} from "../views/list/CriteriaEditorWidget";

class NamaRouter {
    start() {
        var that = this;
        that.kendoRouter = new kendo.Router({
            routeMissing: e => that.route(e),
            change: e => that.checkIfCanNavigate(e)
        });
        that.createRoutingsTable();
        that.kendoRouter.start();
    }

    createRoutingsTable() {
        let map = this.routings = new Map();
        map.set(placeTokens.PREFIX_EDIT, places.EditPlace);
        map.set(placeTokens.PREFIX_LIST, places.EntityListPlace);
        map.set(placeTokens.PREFIX_REPORT_Result, places.ReportViewerPlace);
        map.set(placeTokens.PREFIX_LAUNCH_REPORT, places.ReportLauncherPlace);
        map.set(placeTokens.PREFIX_login, places.LoginPlace);
        map.set(placeTokens.PREFIX_WELCOME, places.WelcomePlace);
        map.set(placeTokens.PREFIX_REPORT_List, places.ListReportPlace);
        map.set(placeTokens.PREFIX_sql, places.SQLPlace);
        map.set(placeTokens.FIELDS_SELECTOR_POPUP, places.FieldsSelectorPlace);
        map.set(placeTokens.WIZARD_VIEW, places.WizardPlace);
        map.set(placeTokens.LAYOUT_EDITOR_VIEW, places.LayoutEditorPlace);
        map.set(placeTokens.REPORT_WIZARD_EDITOR, places.ReportWizardEditor);
        map.set(placeTokens.REPORT_EXPRESSION_EDITOR, places.ReportExpressionEditor);
        map.set(placeTokens.REPORT_UNION_HANDLING_EDITOR, places.ReportUnionHandlingEditor);
    }

    route(e) {
        let that = this;
        let place = that.calcPlace(e.url);
        let loginPresenter = app.instance.loginPresenter || {};
        let loginInfo = loginPresenter.loginInfo || {};
        if (!loginInfo.loggedIn || !app.instance.loginPresenter) {
            if (!(place instanceof places.LoginPlace)) {
                let previousPlace = place;
                place = new places.LoginPlace();
                place.prevPlace = previousPlace;
                this.updateHistoryURLSilently(place);
            }
        }
        if (!place.isAllowedInCurrentSecurityProfile()) {
            errors.showErrors(translateId("unauthorizedPlace"));
            return;
        }
        destroyKendoWidgets($("#main-wrapper").find("#example.page-content-wrapper"));
        $("#main-wrapper").find("#example.page-content-wrapper").html("");
        if (that.currentPresenter && that.currentPresenter.chartsDrawer) {
            clearTimeout(that.currentPresenter.chartsDrawer.dashBoardTimeout);
            for (let [widgetId, widgetTimeOut] of that.currentPresenter.chartsDrawer.widgetTimeout)
                clearTimeout(widgetTimeOut);
        }
        that.currentPresenter = that.createPresenter(place);
        that.currentPlace = place;
        that.currentPresenter.start();
        that.updateWindowTitle(that.currentPresenter.place);
        that.detectCurrentMenuItem();

    }

    detectCurrentMenuItem() {
        if (noMenu())
            return;
        let that = this;
        let menuElement = $("#menu");
        let API = menuElement.data("mmenu");
        if (!API) {
            setTimeout(() => that.detectCurrentMenuItem(), 2000);
            return;
        }
        let place = that.currentPlace;
        let placesWithDiff = [];
        let allPlaces = [...MainMenu.menuItemsMap.keys()].filter((p) => p.prefix && isNotEmptyOrNull(p.prefix()));
        if (isEmptyOrNull(allPlaces) || place instanceof places.WelcomePlace) {
            API.closeAllPanels();
            return;
        }
        if (place.entityType)
            allPlaces = allPlaces.filter((p) => p.entityType === place.entityType);
        for (let itemPlace of allPlaces) {
            placesWithDiff.push({"place": itemPlace, "diffCount": that.diffBetweenPlaces(place, itemPlace)});
        }
        if (!placesWithDiff || !placesWithDiff.length)
            return;
        placesWithDiff.sort((o1, o2) => namaCompare(o1.diffCount, o2.diffCount));
        let equivalentPlace = placesWithDiff[0].place;
        let listItemID = MainMenu.menuItemsMap.get(equivalentPlace);
        let menuItemLink = menuElement.find("a[id='" + listItemID + "']");
        if (menuItemLink) {
            let current = menuItemLink.parent();
            current.addClass("Selected");
            API.setSelected(current);
            API.openPanel(current.closest(".mm-panel"));
        }
    }

    /**
     *
     * @param p1 {NamaPlace}
     * @param p2  {NamaPlace}
     * @return {number}
     */
    diffBetweenPlaces(p1, p2) {
        let diffCount = 1;
        let p1Src = p1.params.get(placeTokens.PRM_MENU_HASH);
        let p2Src = p2.params.get(placeTokens.PRM_MENU_HASH);
        if (p1Src && p2Src && areEqual(p1Src, p2Src))
            return 0;
        let keys = [...p1.params.keys()];
        for (let k of p2.params.keys()) {
            if (!keys.contains(k))
                keys.push(k);
        }
        for (let key of keys) {
            if (p1.params.get(key) != p2.params.get(key))
                diffCount++;
        }
        return diffCount;
    }

    updateWindowTitle(place) {
        let that = this;
        if (!place)
            return;
        let windowTitle = place.windowTitle();
        if (windowTitle)
            document.title = that.calcWindowTitle(windowTitle);
    }

    calcWindowTitle(subtitle) {
        let userName = "";
        if (isCurrentLogInInfoValid())
            userName = " - " + currentLoginInfo().userInfo ? getFirstNotNullObj(getName(currentLoginInfo().userInfo.name1, currentLoginInfo().userInfo.name2),
                currentLoginInfo().userInfo.code, currentLoginInfo().userInfo.id) : "";
        let applicationName = translateId("applicationName");
        let companyName = "";//window.companyName;
        if (companyName)
            applicationName += " " + companyName + " - " + applicationName;
        return applicationName + " - " + subtitle + " - " + userName;
    }

    createPresenter(place) {
        if (place instanceof places.EditPlace)
            return new editPresenter.EditPresenter(place);
        else if (place instanceof places.EntityListPlace)
            return new presenters.ListPresenter(place);
        else if (place instanceof places.ReportViewerPlace)
            return new presenters.ReportViewerPresenter(place);
        else if (place instanceof places.ReportLauncherPlace)
            return new presenters.ReportLauncherPresenter(place);
        else if (place instanceof places.LoginPlace)
            return new presenters.LoginPresenter(place);
        else if (place instanceof places.WelcomePlace)
            return new presenters.WelcomePresenter(place);
        else if (place instanceof places.WizardPlace)
            return new presenters.WizardPresenter(place);
        else if (place instanceof places.FieldsSelectorPlace)
            return new presenters.FieldsSelectorPresenter(place);
        else if (place instanceof places.LayoutEditorPlace)
            return new presenters.LayoutEditorPresenter(place);
        else if (place instanceof places.ReportWizardEditor)
            return new presenters.ReportWizardEditorPresenter(place);
        else if (place instanceof places.ReportExpressionEditor)
            return new presenters.ReportExpressionEditorPresenter(place);
        else if (place instanceof places.ReportUnionHandlingEditor)
            return new presenters.ReportUnionHandlingEditorPresenter(place);
        else if (place instanceof places.SQLPlace)
            return new presenters.SQLPresenter(place);
        return new presenters.NamaPresenter(place);
    }

    /**
     *
     * @param url
     * @return {NamaPlace}
     */
    calcPlace(url) {
        if (!url || url === '/')
            return new places.WelcomePlace();
        let prefix = cmn.substringBefore(url, ":");
        let tokens = cmn.substringAfter(url, ":");
        if (!prefix)
            return new places.WelcomePlace({tokens})
        let placeClass = this.routings.get(prefix);
        if (!placeClass)
            throw new Error(`Could not find place for ${prefix}`);
        let place = new placeClass({tokens});
        place.createdObject = this.lastPlaceCreatedObject;
        place.embeddedReportView = this.lastPalceIsEmbeddedReport;
        place.embeddedViewContainer = this.lastPalceEmbeddedReportContainer;
        place.prevPlace = this.lastPalcePreviousPlace;
        this.lastPlaceCreatedObject = undefined;
        this.lastPalceIsEmbeddedReport = undefined;
        this.lastPalceEmbeddedReportContainer = undefined;
        return place;
    }

    checkIfCanNavigate(e) {
        if (this.currentPlace) {
            let {canNavigate, msg} = this.currentPresenter.canNavigate();
            if (canNavigate)
            {
                this.currentPresenter.beforeClosing();
                return;
            }
            if (!window.confirm(msg)) {
                e.preventDefault();
                return;
            }
            this.currentPresenter.beforeClosing();
        }
    }

    get started() {
        return this.kendoRouter !== undefined;
    }

    goTo(place) {
        let that = this;
        let link = NamaRouter._placeToLink(place);
        that.lastPlaceCreatedObject = place.createdObject;
        that.lastPalceIsEmbeddedReport = place.embeddedReportView;
        that.lastPalceEmbeddedReportContainer = place.embeddedViewContainer;
        that.lastPalcePreviousPlace = place.prevPlace;
        that.kendoRouter.navigate(link);
        that.updateWindowTitle(place);
    }

    static _placeToLink(place) {
        let link = place;
        if (place.fullLink)
            link = place.fullLink();
        return link;
    }

    updateHistoryURLSilently(place) {
        let link = NamaRouter._placeToLink(place);
        this.kendoRouter.replace(link, true)
    }
}

export const NamaRouterInstance = new NamaRouter();

export function start() {
    if (NamaRouterInstance.started)
        return;
    NamaRouterInstance.start();
}
